// Кэш словарей фильтров (проекты, категории, расширения, теги).
//
// Зачем: на холодном старте эти четыре списка грузятся четырьмя независимыми запросами,
// и каждый показывает собственный спиннер — экран «рассыпается» на несвязанные лоадеры.
// Списки при этом маленькие и меняются редко, поэтому их можно показать мгновенно из
// прошлой сессии, а свежие данные подтянуть в фоне (SWR).
//
// Кэш живёт в одном слайсе (а не по одному в каждом словаре), чтобы гидрация из
// localStorage и персист были в одном месте — иначе это четыре копии одного и того же кода.

import { Category, Extension, Project, Tag } from '../../api';
import { CachedRecord } from '../../cache';

// Общая часть записи (storedAt/revalidate) и правило устаревания — в assetLab/cache.ts:
// запись из прошлой сессии или пролежавшая дольше SESSION_STALE_MS показывается мгновенно
// и тихо обновляется из сети, свежая запись этой сессии запроса не вызывает.
export type DictionaryEntry<T> = CachedRecord & {
  items: T[];
};

export type DictionaryCache<T> = Record<string, DictionaryEntry<T>>;

// Единственное место, где имя словаря связано с типом его элементов. Всё остальное
// (форма слайса, payload экшена, параметры loadDictionary) выводится отсюда.
type DictionaryItems = {
  project: Project;
  category: Category;
  extension: Extension;
  tag: Tag;
};

export type DictionaryName = keyof DictionaryItems;

export type DictionaryItem<N extends DictionaryName> = DictionaryItems[N];

export type FiltersCacheShape = {
  [N in DictionaryName]: DictionaryCache<DictionaryItem<N>>;
};

export const DICTIONARY_NAMES: DictionaryName[] = ['project', 'category', 'extension', 'tag'];

// Сколько разных наборов фильтров храним на словарь. Значение небольшое: практически
// полезны последние 2-3 (текущая локация и та, откуда пришли), остальное — балласт.
export const MAX_ENTRIES_PER_DICTIONARY = 4;
